var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalMainStLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 64,
    viewBox: "0 0 79 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3691 23.2188C14.5936 23.2188 15.1841 22.4509 15.1841 21.0439V13.1407C15.1841 11.7369 14.5936 10.9664 13.3474 10.9664H11.5107V23.2188H13.3691ZM13.3914 9.4082C15.7734 9.4082 16.8671 10.8588 16.8671 13.2304V20.9798C16.8671 23.3303 15.774 24.779 13.3914 24.779H9.80542V9.4082H13.3914Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4524 9.4082H18.7471V24.7777H20.4524V9.4082Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4381 13.1191V14.4371H27.8208V13.0313C27.8208 11.6492 27.2743 10.8147 26.0275 10.8147C24.803 10.8147 24.2342 11.6492 24.2342 13.0313V21.1567C24.2342 22.5394 24.803 23.3746 26.0275 23.3746C27.2736 23.3746 27.8208 22.5394 27.8208 21.1567V18.0813H26.2462V16.5461H29.4381V21.069C29.4381 23.3957 28.345 24.9328 25.9835 24.9328C23.6443 24.9328 22.5505 23.3957 22.5505 21.069V13.121C22.5505 10.793 23.6443 9.25782 25.9835 9.25782C28.3444 9.25525 29.4381 10.791 29.4381 13.1191Z",
    fill: "#8F8F8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7448 9.4082H32.0388V24.7777H33.7448V9.4082Z",
    fill: "#8F8F8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0733 24.7777V10.9671H35.2532V9.4082H42.5993V10.9671H39.7786V24.7777H38.0733Z",
    fill: "#8F8F8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7414 20.2106H48.1527L46.4257 11.3404L44.7414 20.2106ZM44.5226 21.6818L43.9321 24.7777H42.3582L45.2879 9.4082H47.7592L50.6889 24.7777H48.9836L48.3937 21.6818H44.5226Z",
    fill: "#8F8F8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4587 24.7777V9.4082H54.1641V23.2188H58.537V24.7777H52.4587Z",
    fill: "#8F8F8F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4454 50.1003H13.8065L11.2695 37.8703V50.1214H9.78296V34.752H12.1662L14.6808 47.0268L17.1074 34.752H19.4906V50.1214H17.8727V37.7601L15.4454 50.1003Z",
    fill: "#8F8F8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.791 45.5557H26.2023L24.4753 36.6842L22.791 45.5557ZM22.5729 47.0268L21.9824 50.1214H20.4084L23.3382 34.752H25.8088L28.7386 50.1214H27.0333L26.4434 47.0268H22.5729Z",
    fill: "#8F8F8F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7334 34.752H30.0281V50.1214H31.7334V34.752Z",
    fill: "#8F8F8F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.931 50.1214H34.4004V34.752H36.5649L40.1069 45.8625V34.752H41.6151V50.1214H39.8441L35.931 37.6942V50.1214Z",
    fill: "#8F8F8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2513 38.4423V38.8586H52.6333V38.3533C52.6333 36.9699 52.1098 36.1578 50.8853 36.1578C49.6615 36.1578 49.1366 36.9699 49.1366 38.3321C49.1366 41.7784 54.2749 42.1082 54.2749 46.4338C54.2749 48.7606 53.1601 50.2752 50.8209 50.2752C48.481 50.2752 47.3879 48.7606 47.3879 46.4338V45.5558H48.9842V46.5216C48.9842 47.9049 49.5524 48.717 50.7769 48.717C52.0013 48.717 52.5702 47.9049 52.5702 46.5216C52.5702 43.0964 47.4543 42.7666 47.4543 38.4423C47.4543 36.0714 48.548 34.5996 50.8426 34.5996C53.1588 34.5996 54.2513 36.1143 54.2513 38.4423Z",
    fill: "#8F8F8F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.968 50.1214V36.3121H55.1479V34.752H62.4934V36.3121H59.6733V50.1214H57.968Z",
    fill: "#8F8F8F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3735 47.9941H62.7339V50.1243H64.3735V47.9941Z",
    fill: "#8F8F8F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7797 54.7447H9.76392V53.0718H66.7797C67.26 53.0718 67.6503 52.6805 67.6503 52.1976L67.6643 32.1324C67.6643 31.6507 67.2746 31.2581 66.7938 31.2581H9.77922V29.5859H66.7938C68.1923 29.5859 69.3313 30.7291 69.3313 32.1343L69.316 52.1995C69.316 53.6015 68.1783 54.7447 66.7797 54.7447Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMainStLogo);
export default __webpack_public_path__ + "static/media/DigitalMainStLogo.b1ced10bb9463be03e304cf489d17689.svg";
export { ForwardRef as ReactComponent };